import React from 'react';
import { Table } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

import { useDynamicTableStyles } from './table.styles';

const DynamicTable = ({
  columns,
  data,
  onRowClick,
  pageSize = 10,
  pagination,
  emptyText = '',
  autoClickableRows = true,
  ...tableProps
}) => {
  const intl = useIntl();
  const { styles } = useDynamicTableStyles();

  const processedColumns = columns.map(column => ({
    ...column,
    render: (text, record, index) => {
      if (text === null || text === undefined || text === '') {
        return <span>{emptyText}</span>;
      }
      if (column.render) {
        return column.render(text, record, index);
      }
      if (column.clickable) {
        return (
          <a
            className="clickable-cell"
            onClick={() => onRowClick && onRowClick(record, column)}
          >
            {text}
          </a>
        );
      }
      return <span className="default-cell">{text}</span>;
    },
  }));

  const getAutoRowClassName = (record, index) => {
    if (!autoClickableRows) return '';

    const hasClickableData = columns.some(
      col =>
        col.clickable &&
        record[col.dataIndex] !== undefined &&
        record[col.dataIndex] !== null
    );

    return hasClickableData ? 'clickable-row' : '';
  };

  const paginationConfig = {
    pageSize,
    showSizeChanger: false,
    simple: true,
    showTitle: false,
    itemRender: (_, type, originalElement) => {
      if (type === 'prev') {
        return <CaretLeftOutlined />;
      }
      if (type === 'next') {
        return <CaretRightOutlined />;
      }
      return originalElement;
    },
    ...pagination,
  };

  return (
    <div
      className={styles.dynamicTableContainer}
      style={{
        '--page-label': `"${intl.formatMessage({ id: 'dynamicTable.page' })}"`,
        '--out-of-label': `"${intl.formatMessage({ id: 'dynamicTable.outOf' }, { totalPages: Math.ceil(data?.length / paginationConfig.pageSize) })}"`,
      }}
    >
      <Table
        columns={processedColumns}
        dataSource={data}
        rowKey={record => record.id || record.key}
        pagination={paginationConfig}
        rowClassName={getAutoRowClassName}
        {...tableProps}
      />
    </div>
  );
};

export default DynamicTable;
